<div class="gedcom-container">
  <h2 i18n>My Gedcom</h2>
  <mat-card class="card gedcom-card">
    <mat-card-content>
      <ng-container>
        <div class="loader-div" *ngIf="showLoader">
          <div class="loader"></div>
        </div>
      </ng-container>
      <p i18n class="mat-card-header">UPLOADED GEDCOMS</p>
      <div class="content">
        <app-gedcom-upload></app-gedcom-upload>
       

        <div class="gedcom-status" *ngIf="gedcom?.length > 0">
          <p i18n class="status-title">GEDCOM file status</p>
          <div class="table-container">
            <table mat-table [dataSource]="gedcom" class="mat-elevation-z8 order-table">
              <!-- filename Column -->
              <ng-container matColumnDef="filename">
                <th i18n mat-header-cell *matHeaderCellDef> File name </th>
                <td mat-cell *matCellDef="let element" (click)="getGedcom(element.id)"> {{element.filename}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th i18n mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>

              <!-- Uploaded Column -->
              <ng-container matColumnDef="uploaded">
                <th i18n mat-header-cell *matHeaderCellDef> Uploaded </th>
                <td mat-cell *matCellDef="let element"> {{element.uploaded | date}} </td>
              </ng-container>

              <!-- Persons Column -->
              <ng-container matColumnDef="individuals">
                <th i18n mat-header-cell *matHeaderCellDef> Individuals </th>
                <td mat-cell *matCellDef="let element"> {{element.indis}} </td>
              </ng-container>

              <!-- Size Column -->
              <ng-container matColumnDef="size">
                <th i18n mat-header-cell *matHeaderCellDef> Size </th>
                <td mat-cell *matCellDef="let element"> {{element.size}} </td>
              </ng-container>
              <!-- Delete Column -->
              <ng-container matColumnDef="delete">
                <th i18n mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon (click)="delete(element)">delete</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>